import {
  AlertIcon,
  Card,
  InfoIcon,
  Text,
  WarningOutlineIcon,
  Tooltip,
} from '@mercai/clever'

import { MarginMetricsProps } from './margin-metrics.types'

import styles from './margin-metrics.module.css'

import { useTranslation, Trans } from 'react-i18next'
import {
  generateCm3MarginClasses,
  generateGrossMarginClasses,
  generateIconClasses,
} from './margin-metrics.constants'

export const MarginMetrics = ({
  incomplete,
  cm3Margin,
  grossMargin,
  hasWarehouseDiscount = false,
}: MarginMetricsProps) => {
  const { t } = useTranslation('componentsMarginMetrics')

  const Icon = () => {
    return incomplete ? (
      <div className={`${styles.icon} ${styles['icon--info']}`}>
        <AlertIcon />
      </div>
    ) : (
      <div className={generateIconClasses({ cm3Margin, grossMargin })}>
        {(grossMargin || 0) >= 0.07 && (cm3Margin || 0) >= 0.02 ? (
          <AlertIcon />
        ) : (
          <WarningOutlineIcon />
        )}
      </div>
    )
  }

  return (
    <Card className={styles.core}>
      <div className={styles.title}>
        <Icon />
        <strong className={styles.strong}>{t('projectedUtilities')} </strong>
      </div>
      <div>
        <Text className={styles.title} variant="title-base">
          <Text>
            <Trans
              t={t}
              i18nKey="grossMarginLabel"
              values={{
                value: incomplete ? '-' : ((grossMargin || 0) * 100).toFixed(2),
              }}
              components={{
                strong: <strong className={styles.strong} />,
                span: (
                  <span
                    className={generateGrossMarginClasses(grossMargin || 0)}
                  />
                ),
              }}
            />
          </Text>
          <Text>
            <Trans
              t={t}
              i18nKey="cm3Label"
              values={{
                value: incomplete ? '-' : ((cm3Margin || 0) * 100).toFixed(2),
              }}
              components={{
                strong: <strong className={styles.strong} />,
                span: (
                  <span className={generateCm3MarginClasses(cm3Margin || 0)} />
                ),
              }}
            />
          </Text>

          {hasWarehouseDiscount && (
            <Text className={styles['warehouse-discount']}>
              ({' '}
              <Text className={styles['warehouse-discount-text']}>
                {t('hasWarehouseDiscount')}
              </Text>
              <Tooltip
                text={t('hasWarehouseDiscountTooltip')}
                widthText="17.1875rem"
                orientation="bottom"
              >
                <InfoIcon />
              </Tooltip>
              )
            </Text>
          )}
        </Text>
      </div>
      {incomplete && (
        <div className={styles.incomplete}>
          <Tooltip
            text={t('metricIncompleteLabel')}
            widthText="17.1875rem"
            orientation="bottom"
          >
            <InfoIcon />
          </Tooltip>
        </div>
      )}
    </Card>
  )
}
